import React, { FC, memo, useMemo } from "react";

import { ContainerAlias, ContainerUnits, ContainerValue, RoundedBackgroundContainerWrapper } from "./styled";
import { TextTrim } from "../components/TextTrim/TextTrim";
import { ContainerProps } from "../types";

const ALIAS_DEFAULT_MAX_LENGTH = 28;

export const RoundedBackgroundContainer: FC<ContainerProps> = memo(({ elementConfig, attributes, renderElement }) => {
  const { options, style, children } = elementConfig || {};
  const { maxLength, center, fontColor, innerTemplateStyle, inlineUnits, bigIcon, hideEmpty, colorAttribute } =
    options || {};

  const aliasElement = children?.find(({ id }) => id === "alias");
  const unitsElement = children?.find(({ id }) => id === "units");
  const valueElement = children?.find(({ id }) => id === "value");
  const value = renderElement({ id: "value" });

  const color = useMemo(
    () => (attributes.find(({ name }) => name === colorAttribute)?.value as string) || fontColor,
    [attributes, colorAttribute, fontColor],
  );

  if (!value && hideEmpty) return null;

  return (
    <RoundedBackgroundContainerWrapper
      style={innerTemplateStyle || style}
      $center={center}
      $color={color}
      $inlineUnits={inlineUnits}
      $bigIcon={bigIcon}
    >
      {renderElement({ id: "icon", wrap: false })}
      <ContainerValue style={valueElement?.style} big>
        {value}
        {!!unitsElement && (
          <ContainerUnits style={unitsElement?.style}>{renderElement({ id: "units" })}</ContainerUnits>
        )}
      </ContainerValue>
      <ContainerAlias style={aliasElement?.style}>
        <TextTrim maxLength={maxLength || ALIAS_DEFAULT_MAX_LENGTH}>
          {renderElement({ id: "alias", wrap: false })}
        </TextTrim>
      </ContainerAlias>
    </RoundedBackgroundContainerWrapper>
  );
});
